import React, {useCallback, useState} from 'react';
import SkillsForm from './SkillsForm';
import {toast} from 'react-toastify';
import {COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy} from '../../../../service/toastService';
import SkillsList from './SkillsList';
import {createMultipleCurriculumVitaeSkills, deleteCurriculumVitaeSkill, updateCurriculumVitaeSkill} from '../../../../api/curriculumVitaeApi';
import {useDispatch} from 'react-redux';
import {showModal} from '../../../../redux/system/actions';
import ConfirmModal from '../../../common/modals/ConfirmModal';

const CONFIRM_MODAL_ID = 'confirmModal';

function Skills({curriculumVitae, setCurriculumVitae}) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [skills, setSkills] = useState(curriculumVitae.curriculumVitaeSkills || []);
    const [editingSkill, setEditingSkill] = useState(null);
    const [skillToDelete, setSkillToDelete] = useState(null);

    const handleSaveSkill = async (skillData) => {
        try {
            if (editingSkill) {
                const updatedSkillData = {
                    ...skillData,
                    skillName: skillData.skillName[0]
                };
    
                const updatedSkill = await updateCurriculumVitaeSkill(updatedSkillData);
                const updatedSkills = skills.map((skill) =>
                    skill.id === skillData.id ? updatedSkill.data : skill
                );
    
                setSkills(updatedSkills);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeSkills: updatedSkills,
                }));
                toast.success('Skill updated successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES));
            } else {
                const formattedSkills = skillData.skillName.map((skill) => ({
                    skillName: skill,
                    skillType: skillData.skillType,
                    skillRating: skillData.skillRating,
                    curriculumVitaeId: skillData.curriculumVitaeId,
                }));
    
                const newSkills = await createMultipleCurriculumVitaeSkills(formattedSkills);
                const updatedSkills = [...skills, ...newSkills.data];
    
                setSkills(updatedSkills);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeSkills: updatedSkills,
                }));
                toast.success('Skills added successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES));
            }
    
            setEditingSkill(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES));
            setEditingSkill(null);
        }
    };
    
    
    const handleDeleteSkill = async () => {
        if (!skillToDelete) return;
        try {
            await deleteCurriculumVitaeSkill(skillToDelete);
            setSkills((prevSkills) => prevSkills.filter((skill) => skill.id !== skillToDelete));
            setCurriculumVitae((prevCv) => {
                const updatedSkills = prevCv.curriculumVitaeSkills.filter((skill) => skill.id !== skillToDelete);
                return {
                    ...prevCv,
                    curriculumVitaeSkills: updatedSkills,
                };
            });
            toast.success('Skill deleted successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES));
            setSkillToDelete(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_SKILL_TOAST_MESSAGES));
        }
    };

    const handleEditSkill = (skill) => {
        setEditingSkill(skill);
    };

    const confirmDeleteSkill = (skillId) => {
        setSkillToDelete(skillId);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    return (
        <div>

            <h4 className="mb-4" style={{textDecoration: 'underline', textUnderlineOffset: '7px'}}>
                Skills
            </h4>

            <SkillsForm curriculumVitaeId={curriculumVitae.id} initialSkill={editingSkill} setEditingSkill={setEditingSkill} onSave={handleSaveSkill}/>

            <SkillsList skills={skills} onEdit={handleEditSkill} onDelete={confirmDeleteSkill}/>

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this skill?"
                message="This will permanently remove the selected skill from your profile. Do you wish to proceed?"
                onConfirm={handleDeleteSkill}
            />
        </div>
    );
}

export default Skills;